import React, { Component } from 'react'
import PropTypes from 'prop-types'
import api from './api'
import _ from 'lodash'
import { Modal, Radio } from 'react-bootstrap'
import RigSupervisorsTableForm from './rig-supervisors-table-form'
import RigsSupervisorsView from './rig-supervisors-view'
import i18n from 'live/services/i18n'
import normalizeRigs from './normalize-rigs'
import FormErrorDialog from 'live/components/actions/ui/form-error-dialog'
import FormTestWarningDialog from './test-warning-dialog'

const FormGroup = require('live/components/forms/ui/form-group')

export default class EditModal extends Component {

    tableConfig = [
        {
            label: i18n('USE IN CALCULATION'),
            name: 'activeOnSupervisorManagementRule',
            type: 'checkbox',
            cols: 1
        },
        {
            label: i18n('RIG'),
            name: 'name',
            type: 'readonly',
            cols: 2
        },
        {
            label: i18n('EXP / ARAP / AUP'),
            name: 'area',
            type: 'select',
            placeholder: i18n('Select'),
            options: [
                { value: 'EXP', label: i18n('EXP') },
                { value: 'ARAP', label: i18n('ARAP') },
                { value: 'AUP', label: i18n('AUP') }
            ],
            searchable: false,
            cols: 3
        },
        {
            label: i18n('FIXED / FLOATING'),
            name: 'installationType',
            type: 'select',
            placeholder: i18n('Select'),
            options: [{ value: 'fixed', label: i18n('fixed') }, { value: 'floating', label: i18n('floating') }],
            searchable: false,
            cols: 2
        },
        {
            label: i18n('TYPE'),
            name: 'rigType',
            type: 'select',
            placeholder: i18n('Select'),
            options: [
                { value: 'dualActive', label: i18n('dualActive') },
                { value: 'tripSaver', label: i18n('tripSaver') },
                { value: 'sequential', label: i18n('sequential') }
            ],
            searchable: false,
            cols: 2
        },
        {
            label: i18n('PENTAGON'),
            name: 'pentagonCoefficient',
            type: 'number',
            cols: 2
        }
    ]

    constructor (props) {
        super(props)

        this.state = {
            rigsLoading: true,
            rigs: false,
            config: props.config ? props.config : {},
            saving: false,
            saved: false,
            showErrors: false
        }
    }

    static propTypes = {
        onHide: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired
    }

    onHide = () => {
        this.setState({
            mode: 'editing',
            saving: false,
            saved: false
        })

        this.props.onHide()
    }

    UNSAFE_componentWillMount () {
        this.getEditData()
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        this.setState({ config: nextProps.config ? nextProps.config : {} })
    }

    onChangeRigInfoTable = values => {
        this.setState({
            rigs: values
        })
    }

    getEditData () {
        api.getRigsEdit(
            data => {
                _.map(data, (rig, key) => {
                    if (rig.pentagonCoefficient === 0) data[key].pentagonCoefficient = '0'
                })
                this.setState({
                    rigsLoading: false,
                    rigs: data
                })
            },
            error => {
                this.setState({
                    rigsLoading: false,
                    rigs: []
                })

                alert(error)
            }
        )
    }

    checkValidation = () => {
        let valid = true

        _.map(this.state.rigs, (rig, key) => {
            if (
                rig.pentagonCoefficient === '' ||
                rig.pentagonCoefficient === undefined ||
                rig.pentagonCoefficient === null
            )
                rig.pentagonCoefficient = null

            if (rig.installationType === 'fixed') {
                if (rig.area === 'EXP' || rig.area === 'AUP') {
                    rig.installationType = 'floating'
                    this.state.rigs[key].installationType = 'floating'
                }

                rig.pentagonCoefficient = null
                this.state.rigs[key].pentagonCoefficient = null
            }

            if (rig.activeOnSupervisorManagementRule) {
                if (!rig.area || !rig.installationType || !rig.rigType) valid = false

                if (!rig.pentagonCoefficient && rig.installationType !== 'fixed') valid = false
            }
        })

        return valid
    }

    onSave = () => {
        this.setState({
            saving: true
        })

        if (!this.checkValidation()) {
            this.setState({
                saving: false,
                showSaveFormErrorDialog: true
            })

            return
        }

        api.save(
            this.state.config,
            this.state.rigs,
            () => {
                this.setState({
                    saving: false,
                    saved: true
                })

                this.props.onSave(this.onHide)
            },
            error => {
                this.setState({
                    saving: false,
                    saved: false
                })

                alert('Unable to save: ' + error)
            }
        )
    }

    onTest = () => {
        if (!this.checkValidation()) {
            this.setState({
                showTestFormErrorDialog: true
            })

            return
        }

        api.testCalculations(
            this.state.rigs,
            this.state.config,
            ({ data }) => {
                normalizeRigs(data.rigLists)

                this.setState({
                    mode: 'testing',
                    testData: data
                })
            },
            error => {
                alert('Unable to test: ' + error)
            }
        )
    }

    onChangeInputMode = event => {
        let config = this.state.config

        config.mode = event.currentTarget.value

        this.setState({
            config: config
        })
    }

    onChangeNARAPSupervisors = event => {
        let config = this.state.config

        config.nSupervisorsARAP = parseInt(event.currentTarget.value)

        this.setState({
            config: config
        })
    }

    onChangeNAUPSupervisors = event => {
        let config = this.state.config

        config.nSupervisorsAUP = parseInt(event.currentTarget.value)

        this.setState({
            config: config
        })
    }

    onChangeNEXPSupervisors = event => {
        let config = this.state.config

        config.nSupervisorsEXP = parseInt(event.currentTarget.value)

        this.setState({
            config: config
        })
    }

    onChangePercentageOfFloatingARAPRigsWith3Supervisors = event => {
        let config = this.state.config

        config.percentageOfFloatingARAPRigsWith3Supervisors = parseFloat(event.currentTarget.value)

        this.setState({
            config: config
        })
    }

    onChangePercentageOfFloatingAUPRigsWith3Supervisors = event => {
        let config = this.state.config

        config.percentageOfFloatingAUPRigsWith3Supervisors = parseFloat(event.currentTarget.value)

        this.setState({
            config: config
        })
    }

    onChangePercentageOfFloatingEXPRigsWith3Supervisors = event => {
        let config = this.state.config

        config.percentageOfFloatingEXPRigsWith3Supervisors = parseFloat(event.currentTarget.value)

        this.setState({
            config: config
        })
    }

    render () {
        const { config, rigs, rigsLoading, saving, saved, showErrors, mode, testData } = this.state
        const inputAddon = (
            <span className="supervisor-input-addon">
                <i className="fa fa-percent" />
            </span>
        )
        let btnCls = 'btn btn-primary'

        if (saving || saved || showErrors) btnCls += ' disabled'

        if (saved) btnCls += ' btn-success'

        const labelInputTypeSupervisorAmount = i18n(
            'Insert total number of rig supervisors, considering floating and fixed rigs'
        )
        const labelInputTypeFloatingRigPercentage = i18n(
            'Insert percentage of FLOATING rigs with more than 3 supervisors'
        )
        let labelInputType
        let percentageOfFloatingARAPRigsWith3Supervisors
        let percentageOfFloatingAUPRigsWith3Supervisors
        let percentageOfFloatingEXPRigsWith3Supervisors

        if (config) {
            if (config.mode === 'supervisorAmountInput') labelInputType = labelInputTypeSupervisorAmount
            else labelInputType = labelInputTypeFloatingRigPercentage

            percentageOfFloatingARAPRigsWith3Supervisors = config.percentageOfFloatingARAPRigsWith3Supervisors
            percentageOfFloatingAUPRigsWith3Supervisors = config.percentageOfFloatingAUPRigsWith3Supervisors
            percentageOfFloatingEXPRigsWith3Supervisors = config.percentageOfFloatingEXPRigsWith3Supervisors
        }

        return (
            <div>
                <Modal
                    {...this.props}
                    animation={false}
                    className={`modal-sm rig-supervisors-management-modal`}
                    onHide={this.onHide}
                >
                    <Modal.Header>
                        <Modal.Title>{i18n('Edit rig supervisor calculations')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {rigsLoading ? (
                            <div className="rig-supervisor-info__edit-container"> LOADING </div>
                        ) : mode === 'testing' ? (
                            <RigsSupervisorsView
                                rigLists={testData.rigLists}
                                rigsConfig={testData.config}
                                showTitle={false}
                                headerAddon={
                                    <div style={{ textAlign: 'center' }}>
                                        <button
                                            onClick={() =>
                                                this.setState({
                                                    mode: 'editing',
                                                    saving: false,
                                                    saved: false
                                                })
                                            }
                                            className="btn btn-primary"
                                        >
                                            {i18n('Return to edit mode')}
                                        </button>
                                    </div>
                                }
                            />
                        ) : (
                            <div>
                                <div className="rig-supervisor-info_edit_container">
                                    <RigSupervisorsTableForm
                                        visibleRows={0}
                                        fields={this.tableConfig}
                                        data={rigs}
                                        onChange={this.onChangeRigInfoTable}
                                        hasClear={false}
                                        hideAddButton={true}
                                    />
                                </div>

                                <div className="rig-supervisor-config__edit-container">
                                    <div className="input-type-selection">
                                        <Radio
                                            name="input-type"
                                            checked={config && config.mode === 'supervisorAmountInput'}
                                            value="supervisorAmountInput"
                                            onChange={this.onChangeInputMode}
                                        >
                                            {i18n('Calculate by number of rig supervisors')}
                                        </Radio>
                                        <Radio
                                            name="input-type"
                                            checked={
                                                config &&
                                                config.mode === 'percentageOfFloatingRigsWith3SupervisorsInput'
                                            }
                                            value="percentageOfFloatingRigsWith3SupervisorsInput"
                                            onChange={this.onChangeInputMode}
                                        >
                                            {i18n(
                                                'Calculate by percentage of floating rigs with more than 3 supervisors'
                                            )}
                                        </Radio>
                                    </div>
                                    <div className="input-values">
                                        <span>{labelInputType}</span>

                                        {config && config.mode === 'supervisorAmountInput' ? (
                                            <div className="input-values-form">
                                                <FormGroup
                                                    type="number"
                                                    min="0"
                                                    label={
                                                        <span>
                                                            {i18n('ARAP Rig Supervisors')}{' '}
                                                            <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="nSupervisorsARAP"
                                                    value={config.nSupervisorsARAP || '0'}
                                                    onChange={this.onChangeNARAPSupervisors}
                                                />
                                                <FormGroup
                                                    type="number"
                                                    min="0"
                                                    label={
                                                        <span>
                                                            {i18n('AUP Rig Supervisors')}{' '}
                                                            <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="nSupervisorsAUP"
                                                    value={config.nSupervisorsAUP || '0'}
                                                    onChange={this.onChangeNAUPSupervisors}
                                                />
                                                <FormGroup
                                                    type="number"
                                                    min="0"
                                                    label={
                                                        <span>
                                                            {i18n('EXP Rig Supervisors')}{' '}
                                                            <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="nSupervisorsEXP"
                                                    value={config.nSupervisorsEXP || '0'}
                                                    onChange={this.onChangeNEXPSupervisors}
                                                />

                                                <div className="test-calculation-container">
                                                    <button className={'btn btn-default'} onClick={this.onTest}>
                                                        <span>{i18n('Test calculation')}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="input-values-form">
                                                <FormGroup
                                                    type="number"
                                                    min="0"
                                                    step=".01"
                                                    label={
                                                        <span>
                                                            {i18n('ARAP')} <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="percentageOfFloatingARAPRigsWith3Supervisors"
                                                    value={percentageOfFloatingARAPRigsWith3Supervisors || '0'}
                                                    addonAfter={inputAddon}
                                                    onChange={this.onChangePercentageOfFloatingARAPRigsWith3Supervisors}
                                                />
                                                <FormGroup
                                                    type="number"
                                                    min="0"
                                                    step=".01"
                                                    label={
                                                        <span>
                                                            {i18n('AUP')} <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="percentageOfFloatingAUPRigsWith3Supervisors"
                                                    value={percentageOfFloatingAUPRigsWith3Supervisors || '0'}
                                                    addonAfter={inputAddon}
                                                    onChange={this.onChangePercentageOfFloatingAUPRigsWith3Supervisors}
                                                />
                                                <FormGroup
                                                    type="number"
                                                    min="0"
                                                    step=".01"
                                                    label={
                                                        <span>
                                                            {i18n('EXP')} <abbr title="required">*</abbr>
                                                        </span>
                                                    }
                                                    name="percentageOfFloatingEXPRigsWith3Supervisors"
                                                    value={percentageOfFloatingEXPRigsWith3Supervisors || '0'}
                                                    addonAfter={inputAddon}
                                                    onChange={this.onChangePercentageOfFloatingEXPRigsWith3Supervisors}
                                                />
                                                <div className="test-calculation-container">
                                                    <button className={'btn btn-default'} onClick={this.onTest}>
                                                        <span>{i18n('Test calculation')}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button className={btnCls} onClick={this.onSave}>
                            {saving && !saved ? (
                                <span>
                                    <i className="fa fa-spinner fa-spin" /> {i18n('Saving')}
                                </span>
                            ) : null}
                            {!saving && saved ? (
                                <span>
                                    <i className="fa fa-check" /> {i18n('Saved')}
                                </span>
                            ) : null}
                            {!saving && !saved ? <span>{i18n('Save')}</span> : null}
                        </button>
                        <a className="cancel" onClick={this.props.onHide}>
                            {i18n('cancel')}
                        </a>
                    </Modal.Footer>
                </Modal>
                <FormErrorDialog
                    show={this.state.showSaveFormErrorDialog}
                    onHide={() => this.setState({ showSaveFormErrorDialog: false })}
                />
                <FormTestWarningDialog
                    show={this.state.showTestFormErrorDialog}
                    onHide={() => this.setState({ showTestFormErrorDialog: false })}
                />
            </div>
        )
    }

}
